import React from 'react'
import PropTypes from 'prop-types'

export const Avatar = ({ src, size }) => (
  <div style={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    }}
  >
    <div style={{
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundColor: '#ccc',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
      }}
    />
  </div>
)

Avatar.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired
}

export default Avatar



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/Avatar/index.js